module.exports = __webpack_public_path__ + "img/Planted_Logo_Sand.fd7c27db.png";